<template>
    <div class="news-card" @click="$emit('click')">
        <div class="logo">
            <img :src="logo" alt="">
        </div>
        <div class="desc">
            {{ desc }}
        </div>
    </div>
</template>

<script>
export default {
    props:{
        desc:"",
        logo:''
    }
}
</script>


<style scoped lang="less">
.news-card{
  background: #332A25;
  height: 98px;
  padding: 8px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  //align-items: center;
  .logo{
    width: 30%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .desc{
    flex: 1;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 10px;
    color: #b8a294;
    font-size: 16px;
  }
}
</style>
